// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"364613bc3d41a47b320f","293":"e4c2ea5927955084d516","518":"c32b40fc20d621bf02c9","779":"0d1798575d532918edb8"}[chunkId] + ".js";
};